// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unnecessary-type-constraint
export const clone = <T extends any = any>(data: T): T =>
	typeof structuredClone === "function"
		? structuredClone(data)
		: JSON.parse(JSON.stringify(data));
